import { app } from '../../app.module'
app
  // アカウントタグ管理モーダル
  .directive('editAccountTagModal', () => {
    return {
      restrict: 'A',
      controller: ($rootScope, $scope, $mdDialog, EditAccountTagModalService) => {
        // モーダルに紐づけられたスコープから、必要な情報を取得
        const snsType: string = $scope.snsType
        const accountId: number = $scope.accountId
        let accountUrlBasePath: string

        // SNS種別ごとに、アカウントのURLのパスを指定する
        switch (snsType) {
          case 'facebook':
            accountUrlBasePath = 'https://www.facebook.com/'
            break

          case 'twitter':
            accountUrlBasePath = 'https://x.com/'
            break

          case 'instagram':
            accountUrlBasePath = 'https://www.instagram.com/'
            break

          case 'youtube':
            accountUrlBasePath = 'https://www.youtube.com/channel/'
            break
          case 'tiktok':
            accountUrlBasePath = 'https://www.tiktok.com/'
            break
        }

        // SNS種別とアカウントIDをキーに、アカウントデータを取得する
        EditAccountTagModalService.common
          .getAccountById(snsType, accountId, $rootScope.groupId, $rootScope.userId)
          .then((account) => {
            $scope.accountScreenName = account.accountScreenName
            $scope.accountPictureUrl = account.accountPictureUrl
            $scope.accountFollowers = account.accountFollowers
            $scope.accountCategoryName = account.accountCategoryName
            $scope.accountSubCategoryName = account.accountSubCategoryName
            $scope.accountUrl = accountUrlBasePath + account.accountId
          })

        // モーダルを閉じる処理
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
